import React from 'react';
import Styles from './LeilaoDeVeiculosBanner.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import { useLayout } from '@/utils/useLayout';

function LeilaoDeVeiculosBanner() {
  const { width } = useLayout();

  return (
    <>
      <section id="leilao-de-veiculos-banner" className="stacked-banner">
        <div className="bg-image-wrapper">
          {width <= 320 && (
            <picture>
              <source type="image/webp" srcSet="assets/leilao-de-veiculos/hero/banner-320.webp" />
              <source type="image/png" srcSet="assets/leilao-de-veiculos/hero/banner-320.png" />
              <img
                src="assets/leilao-de-veiculos/hero/banner-320.png"
                alt="Homem ao lado de carro em estacionamento de pátio de leilão, simbolizando compra a compra de seu veículo em m leilão de veículos homologado pela Santander Financiamentos."
              />
            </picture>
          )}
          {width > 320 && width <= 450 && (
            <picture>
              <source type="image/webp" srcSet="assets/leilao-de-veiculos/hero/banner-450.webp" />
              <source type="image/png" srcSet="assets/leilao-de-veiculos/hero/banner-450.png" />
              <img
                src="assets/leilao-de-veiculos/hero/banner-450.png"
                alt="Homem ao lado de carro em estacionamento de pátio de leilão, simbolizando compra a compra de seu veículo em m leilão de veículos homologado pela Santander Financiamentos."
              />
            </picture>
          )}
          {width > 450 && width <= 800 && (
            <picture>
              <source type="image/webp" srcSet="assets/leilao-de-veiculos/hero/banner-800.webp" />
              <source type="image/png" srcSet="assets/leilao-de-veiculos/hero/banner-800.png" />
              <img
                src="assets/leilao-de-veiculos/hero/banner-800.png"
                alt="Homem ao lado de carro em estacionamento de pátio de leilão, simbolizando compra a compra de seu veículo em m leilão de veículos homologado pela Santander Financiamentos."
              />
            </picture>
          )}
          {width > 800 && width <= 1280 && (
            <picture>
              <source type="image/webp" srcSet="assets/leilao-de-veiculos/hero/banner-1280.webp" />
              <source type="image/png" srcSet="assets/leilao-de-veiculos/hero/banner-1280.png" />
              <img
                src="assets/leilao-de-veiculos/hero/banner-1280.png"
                alt="Homem ao lado de carro em estacionamento de pátio de leilão, simbolizando compra a compra de seu veículo em m leilão de veículos homologado pela Santander Financiamentos."
              />
            </picture>
          )}
          {width > 1280 && width <= 1360 && (
            <picture>
              <source type="image/webp" srcSet="assets/leilao-de-veiculos/hero/banner-1360.webp" />
              <source type="image/png" srcSet="assets/leilao-de-veiculos/hero/banner-1360.png" />
              <img
                src="assets/leilao-de-veiculos/hero/banner-1360.png"
                alt="Homem ao lado de carro em estacionamento de pátio de leilão, simbolizando compra a compra de seu veículo em m leilão de veículos homologado pela Santander Financiamentos."
              />
            </picture>
          )}
          {width > 1360 && (
            <picture>
              <source type="image/webp" srcSet="assets/leilao-de-veiculos/hero/banner-1440.webp" />
              <source type="image/png" srcSet="assets/leilao-de-veiculos/hero/banner-1440.png" />
              <img
                src="assets/leilao-de-veiculos/hero/banner-1440.png"
                alt="Homem ao lado de carro em estacionamento de pátio de leilão, simbolizando compra a compra de seu veículo em m leilão de veículos homologado pela Santander Financiamentos."
              />
            </picture>
          )}
        </div>
        {/* <div className="fade-banner" /> */}
        {/* <div className="fade-banner-gradiente" /> */}
        <div className="santander-symbol" />

        <div className="text-box-position">
          <ContainerHome24>
            <div className="text-box">
              <h1 className="main-text">Leilão de veículos</h1>
              <p className="alt-text">
                Conheça como funcionam os leilões de veículos parceiros da Santander Financiamentos,
                veja suas vantagens e confira os locais mais próximos de você.
              </p>
              {/* <WhiteButton
                href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF&int_medium=consultar-financiamento:banner&int_campaign=consultar"
                rel="noopener"
                target="_blank"
                className="btn-simulate"
              >
                Consultar
              </WhiteButton> */}
            </div>
          </ContainerHome24>
        </div>
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default LeilaoDeVeiculosBanner;
